import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Button } from 'components/ui/Button';

import { colors, Fonts, spacing } from 'styles/theme';
import {
    Bumper,
    Card,
    ContentScroller,
    HorizontalFlexWrapper,
} from 'styles/shared';

export const EmailConfirmed = () => {
    const navigate = useNavigate();

    const onGoToRoot = () => {
        navigate('/');
    };

    return (
        <ContentScroller>
            <Bumper $minHeight={spacing.xxxLarge} />
            <Card>
                <Fonts.Heading6 $color={colors.grandGreen}>
                    Email Address Updated
                </Fonts.Heading6>
                <Bumper $minHeight={spacing.medium} />
                <Fonts.Medium $color={colors.grandGreen}>
                    Your email address has been successfully updated. You can
                    now sign in with your new email address.
                </Fonts.Medium>
                <Bumper $minHeight={spacing.large} />
                <HorizontalFlexWrapper>
                    <Button onClick={onGoToRoot}>Continue</Button>
                </HorizontalFlexWrapper>
            </Card>
            <Bumper $minHeight={spacing.xxxLarge} />
        </ContentScroller>
    );
};
